export const CreateNewCodeSuffix = " (create new code)";
